module.exports = __webpack_public_path__ + "static/support_bg-93db9693920ec852acd09a4e9e33b414.png";